import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Tab, Tabs, Typography } from '@mui/material';
import { clsx } from 'clsx';
import React, { memo, useCallback, useState } from 'react';

import { GetCompanyResponse } from '~/services/rtkQuery/company/types';

import { Subround } from './components/Subround';
import { Summary } from './components/Summary';
import styles from './styles.module.scss';

interface Props {
  data: GetCompanyResponse['result']['data']['rounds'][number];
  index: number;
  className?: string;
}

const Component: React.FC<Props> = ({ data, index, className }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [expanded, setExpanded] = useState(false);

  const handleActiveTabChange = useCallback((event: React.SyntheticEvent, newValue: number) => {
    event.stopPropagation();

    setActiveTabIndex(newValue);
  }, []);

  const toggleExpanded = useCallback(() => {
    setExpanded(prevValue => !prevValue);
  }, []);

  return (
    <div className={clsx(styles.round, className)}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div className={styles.round__heading} role="button" tabIndex={-1} onClick={toggleExpanded}>
        <div className={styles['round__heading__first-column']}>
          <Typography color="text.primary" fontWeight="700" mb="18px" variant="subtitle1">
            Round {data.type}
          </Typography>
          <Tabs
            indicatorColor="primary"
            scrollButtons="auto"
            value={activeTabIndex === null ? false : activeTabIndex}
            variant="scrollable"
            onChange={handleActiveTabChange}
          >
            {data.sub_rounds.map((subround, index) => (
              <Tab
                key={index}
                label={`Round ${data.type}${index + 1}`}
                sx={{ minHeight: 'initial', height: '48px' }}
              />
            ))}
            <Tab label="Summary" />
          </Tabs>
        </div>
        {expanded ? (
          <ArrowDropUpIcon sx={{ color: 'var(--gray-2-color)' }} />
        ) : (
          <ArrowDropDownIcon sx={{ color: 'var(--gray-2-color)' }} />
        )}
      </div>
      {expanded && (
        <>
          {activeTabIndex < data.sub_rounds.length && (
            <Subround data={data.sub_rounds[activeTabIndex]} roundIndex={index} />
          )}
          {activeTabIndex === data.sub_rounds.length && <Summary data={data} />}
        </>
      )}
    </div>
  );
};

export const Round = memo(Component);
